/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum V1DriverSegmentEnum {
  'driverSegmentNew' = 'new',
  'driverSegmentReactivated' = 'reactivated',
}

export type V1DriverSegment = V1DriverSegmentEnum